 <template>
 <v-container>
    <h4 class="text-center">Zadaj čas možného začiatku upratovania</h4>
    <p class="text-center caption mb-4">(Slúži na filtrovanie upratovačov)</p>
  <v-row justify="center">
   <v-col
       cols="12"
       sm="6"
       md="2"
    >
     <v-menu
        ref="menu1"
        v-model="menu1"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="time1"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="time1"
            label="Od"
            prepend-icon="mdi-clock-time-four-outline"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          :allowed-minutes="al_minutes"
          :max="maxTime"
          v-if="menu1"
          v-model="time1"
          full-width
          @click:minute="saveAndCheck1()"
          format="24hr"
        ></v-time-picker>
      </v-menu>
    </v-col>
     <v-col
       cols="12"
       sm="6"
       md="2"
    >
     <v-menu
        ref="menu2"
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="time2"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field 
            v-model="time2"
            label="Do"
            prepend-icon="mdi-clock-time-four-outline"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          :allowed-minutes="al_minutes"
          :min="minTime"
          v-if="menu2"
          v-model="time2"
          full-width
          @click:minute="saveAndCheck2()"
          format="24hr"
        ></v-time-picker>
      </v-menu>
    </v-col>
    </v-row>
 </v-container>
</template>

<script>
  export default {
    name: "ChooseTime",
    props: [
      'date'
    ],
     data () {
      return {
        time1: null,
        menu1: false,
        time2: null,
        menu2: false,
        al_minutes: [0,15,30,45]
      }
    },
    methods:{
      saveAndCheck1(){
        this.$refs.menu1.save(this.time1)
        if(this.time1 && this.time2){
          this.$emit('change', {from: this.time1, to: this.time2});
        }
      },
      saveAndCheck2(){
        this.$refs.menu2.save(this.time2)
        if(this.time1 && this.time2){
          this.$emit('change', {from: this.time1, to: this.time2});
        }
      }
    },
    computed:{
      maxTime() {
        let maxTime = "22:45";
        if(this.time2){
          let t2 = this.time2.split(":");
          let h = +t2[0]-1;
          maxTime = `${h}:${t2[1]}`;
        } 
        return maxTime;
      },
      minTime() {
        let minTime = "01:00";
        if(this.time1){
          let t1 = this.time1.split(":");
          let h = +t1[0]+1;
          minTime = `${h}:${t1[1]}`;
        } 
        return minTime;
      }
    }
  }
</script>

